// src/pages/EventPayment.js

export default function EventPayment({
    isFree,
    event,
    amount,
    currency = "CAD",
    summaryFields = [],
    selectedMethod,
    onSelectMethod,
    submitting,
    submitError,
    onBack,
  }) {
    const hasAmount =
      typeof amount === "number" && !Number.isNaN(amount);
  
    const canProceed = isFree || !!selectedMethod;
  
    const formatAmount = () => {
      if (!hasAmount) return "";
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
      }).format(amount);
    };
  
    const methods = [
      { id: "card", label: "Credit / Debit Card", icon: "💳" },
      { id: "paypal", label: "PayPal", icon: "💻" },
      { id: "venmo", label: "Venmo", icon: "📱" },
      // add/remove as needed
    ];
  
    return (
      <>
        {/* ORDER + USER SUMMARY */}
        <section className="checkout-summary-card" aria-label="Order summary">
          <div className="checkout-summary-header">
            <button
              type="button"
              className="checkout-summary-back"
              onClick={onBack}
            >
              ← Edit details
            </button>
            <h2 className="checkout-summary-title">Review your order</h2>
          </div>
  
          {/* Event info */}
          <div className="checkout-summary-row">
            <div className="checkout-summary-label">Event</div>
            <div className="checkout-summary-value">
              {event?.name || "Event"}
              {event?.baseStartUTC && (
                <div className="checkout-summary-sub">
                  {new Date(event.baseStartUTC).toLocaleString(undefined, {
                    dateStyle: "medium",
                    timeStyle: "short",
                  })}
                </div>
              )}
            </div>
          </div>
  
          {/* Amount */}
          {hasAmount && (
            <div className="checkout-summary-row">
              <div className="checkout-summary-label">Total</div>
              <div className="checkout-summary-value checkout-summary-amount">
                {formatAmount()}
                {isFree && (
                  <span className="checkout-summary-pill">
                    Free
                  </span>
                )}
              </div>
            </div>
          )}
  
          {/* Registration info */}
          {summaryFields.length > 0 && (
            <div
              className="checkout-summary-subsection"
              aria-label="Registration info"
            >
              {summaryFields.map((field) =>
                !field.value ? null : (
                  <div
                    key={field.label}
                    className="checkout-summary-row checkout-summary-row-condensed"
                  >
                    <div className="checkout-summary-label">
                      {field.label}
                    </div>
                    <div className="checkout-summary-value">
                      {String(field.value)}
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </section>
  
        {/* PAYMENT METHODS */}
        {!isFree && (
          <section
            className="checkout-payment-methods"
            aria-label="Payment method"
          >
            <h3 className="checkout-section-title">
              Choose a payment method
            </h3>
            <div className="checkout-method-grid">
              {methods.map((m) => {
                const selected = selectedMethod === m.id;
                return (
                  <button
                    key={m.id}
                    type="button"
                    className={
                      "payment-method-card" +
                      (selected
                        ? " payment-method-card--selected"
                        : "")
                    }
                    onClick={() => onSelectMethod(m.id)}
                  >
                    <span className="payment-method-icon">
                      {m.icon}
                    </span>
                    <span className="payment-method-label">
                      {m.label}
                    </span>
                  </button>
                );
              })}
            </div>
          </section>
        )}
  
        {/* ERROR */}
        {submitError && (
          <p className="checkout-error-text">
            {submitError}
          </p>
        )}
  
        {/* PROCEED BUTTON */}
        <button
          type="submit"
          className="btn checkout-form-submit"
          disabled={submitting || !canProceed}
        >
          {submitting
            ? isFree
              ? "Submitting…"
              : "Processing…"
            : isFree
            ? "Complete registration"
            : "Proceed to Pay"}
        </button>
      </>
    );
  }
  
